import PropTypes from 'prop-types';
import EmbedPdf from 'components/EmbedPdf';
import { getCMSDocumentSrc } from 'utils/getCMSDocumentSrc';

const EmbedDocumentBlock = ({ value }) => {
  if (!value?.file?.hash) return null;
  return (
    <section className='cms-block cms-block--embed-document py-6 md:py-6 lg:py-8'>
      <div className='w-full md:max-w-3xl lg:max-w-5xl mx-auto px-6'>
        <EmbedPdf src={getCMSDocumentSrc(value.file)} downloadable />
      </div>
    </section>
  );
};

EmbedDocumentBlock.propTypes = {
  value: PropTypes.shape({
    file: PropTypes.object,
  }).isRequired,
};

export default EmbedDocumentBlock;
